import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import { MyReferrals } from '../../../../../core/models/user.model';
import { environment } from '../../../../../../environments/environment';
import { QRCodeComponent } from 'angularx-qrcode';
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiInviteService } from '../../../../../core/services/api/Invite/api-invite';
@Component({
  selector: 'app-invite-2',
  imports: [CommonModule, FormsModule, QRCodeComponent

  ],
  templateUrl: './invite-2.component.html',
  styleUrl: './invite-2.component.css'
})
export class Invite2Component {
  private url = `${environment.urlInvite}`;
  currentLang: "TH" | "EN" = 'TH';
  sub!: Subscription;
  userLanguage: String = 'TH';
  uid: string = '';
  token: string = '';
  isLoading: boolean = false;
  activeTab: 'link' | 'code' = 'link';
  totalReferrals: number = 0;
  referralLink = '';
  referralCode = '';
  obfuscatedCode: string = '';
  isModalOpen = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  constructor(
    private cookieService: CookieService,
    private apiInviteService: ApiInviteService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getInformationUser();
    }, 300);
  }



  /* ----------------------------------------- Function ----------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess(text, detail)
  }

  /* --- Function ---*/
  getInformationUser() {
    this.isLoading = true;
    this.apiInviteService.getReferrals(this.token, this.uid).subscribe({
      next: (response: MyReferrals) => {
        console.log('response', response);
        this.isLoading = false;
        if (response) {
          this.totalReferrals = response.inviteCount;
          this.referralCode = response.inviteCode;
          this.referralLink = this.url + '?ref=' + response.inviteCode;
        } else {
          console.log('No data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
    this.showSuccess(this.currentLang === 'TH' ? 'คัดลอกแล้ว!' : 'Copied!', this.currentLang === 'TH' ? 'ขอบคุณที่ร่วมแชร์สิ่งดีๆน่ะครับ' : 'Thanks for sharing good things!');

    // alert(this.currentLang === 'TH' ? 'คัดลอกแล้ว!' : 'Copied!');
  }
  generateQRCode() {
    // แสดง modal, สร้าง canvas, หรือเปิดหน้าใหม่
    this.obfuscatedCode = this.referralLink;
    this.isModalOpen = true;
  }


  closeModal() {
    this.isModalOpen = false;
  }
  goback() {
    this.router.navigate(['/home']);
  }

}
